let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("iAaum"), load("amDM8"), load("ffEVr"), load("2sCab")]).then(() => parcelRequire('3GuAz'));